import throttle from 'lodash/throttle';

const THROTTLE_DELAY = 50;

/*
  Sticky header functionality, only shown when scrolling up. Solution is based on Shopify Dawn theme
  StickHeader element, see
  https://github.com/Shopify/dawn/blob/5cd1a859751a5fc00e4dd8cf048ee8a67c4bb356/sections/header.liquid#L298
 */

export default function init() {
  const target = document.querySelector<HTMLElement>('.js-sticky-header')!;

  // Set up header height and resize callbacks
  setHeaderHeight(target);
  const resizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      setHeaderHeight(entry.target as HTMLElement);
    }
  });
  resizeObserver.observe(target);

  // Get initial header position
  const originalTargetTop = target.getBoundingClientRect().top + window.scrollY;

  let lastScrollY = window.scrollY;
  const navMenu = document.getElementById('nav-menu')!;

  // Add scroll event listener
  window.addEventListener(
    'scroll',
    throttle(() => {
      const currentScrollY = window.scrollY;
      const originalTargetBottom = originalTargetTop + target.offsetHeight;

      // Scrolling down
      if (currentScrollY > lastScrollY) {
        // Hide if scrolled below the original bounds and the menu is not open
        if (currentScrollY > originalTargetBottom && navMenu.classList.contains('hidden')) {
          requestAnimationFrame(() => hide(target));
        }
      }
      // Scrolling up or at the same position (may be triggered by the nav menu closing)
      else if (currentScrollY <= lastScrollY) {
        // Show if scrolled below the original bounds
        if (currentScrollY > originalTargetBottom) {
          requestAnimationFrame(() => show(target));
        }
        // Reset if scrolled above the original bounds
        else if (currentScrollY <= originalTargetTop && navMenu.classList.contains('hidden')) {
          requestAnimationFrame(() => reset(target));
        }
      }

      lastScrollY = currentScrollY;
    }, THROTTLE_DELAY),
  );

  // Initialise state on page load
  if (window.scrollY > originalTargetTop + target.offsetHeight) {
    requestAnimationFrame(() => {
      show(target);
    });
  }
}

function setHeaderHeight(target: HTMLElement) {
  document.documentElement.style.setProperty('--header-height', `${target.offsetHeight}px`);
}

function hide(target: HTMLElement) {
  target.classList.add('is-hidden', 'is-sticky');
}

function show(target: HTMLElement) {
  target.classList.add('is-sticky', 'is-animated');
  target.classList.remove('is-hidden');
}

function reset(target: HTMLElement) {
  target.classList.remove('is-hidden', 'is-sticky', 'is-animated');
}
